<template>
    <v-layout wrap>

            <v-flex xs12 text-center>
                <v-sheet min-height="50">
                    <div v-if="!exams || exams.length === 0" class="caption">Aún no se han agregado exámenes</div>
                    <v-layout wrap v-else>
                        <v-flex xs12>
                            <v-chip class="ma-1" v-for="(exam, index) in exams" @click.stop="editExam(exam)" :key="`ex-${index}`">
                                {{exam.name}}
                                <v-icon
                                    v-if="!isReadOnly"
                                    color="accent"
                                    right
                                    size="20"
                                    @click.stop="showDetachConfirm(exam)">mdi-close</v-icon>
                            </v-chip>
                        </v-flex>
                    </v-layout>
                </v-sheet>
            </v-flex>

            <kimsa-confirm
                    :close-on-confirm="false"
                    :loading="loadingDetach"
                    ref="detachConfirm"
                    title="Desvincular exámen"
                    content="¿Está seguro que desea quitar este exámen?"
                    :persistent="false"
                    @confirm="detachExam"
            ></kimsa-confirm>

        <physical-exam-form
                :event-id="eventId"
                :readonly="isReadOnly"
                ref="physicalExamForm"
                @update="onExamUpdate"
                @attach="onExamUpdate"
        />

    </v-layout>
</template>

<script>
    import {ApiUtils} from "../../../../utils/ApiUtils";
    import {mapState, mapMutations} from 'vuex'

    import KimsaConfirm from "../../../common/KimsaConfirm.vue";
    import PhysicalExamForm from "./PhysicalExamForm.vue";

    export default{
        components: {KimsaConfirm, PhysicalExamForm},
        props: ['exams', 'readonly', 'eventId'],
        data(){
            return {
                loadingDetach: false,
                loadingEdit: false,
                selectedExam: null
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            editExam(exam){
                var vm = this
                vm.$refs.physicalExamForm.show(
                    JSON.parse(JSON.stringify(exam))
                )
            },
            onExamUpdate(exam){
                this.showSnackBar('Exámen actualizando correctamente')
                this.$emit('update', exam)
            },
            showDetachConfirm(exam){
                var vm = this
                vm.selectedExam = exam
                vm.$refs.detachConfirm.show()
            },
            async detachExam(){

                var vm = this

                if(vm.loadingDetach) return

                vm.loadingDetach = true
                const response = await ApiUtils.makePost(`exams/physical/detach`, {
                        schedule_event_id: vm.selectedExam.pivot.schedule_event_id,
                        physical_exam_id: vm.selectedExam.id
                    })
                vm.loadingDetach = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message, 'Ha ocurrido un error intentando desvincular el examen')
                    return
                }

                vm.$emit('detach', vm.selectedExam)
                vm.$refs.detachConfirm.hide()

            },

            async edit(){
                var vm = this

                if(vm.loadingEdit) return

            }
        },
        computed: {
            isReadOnly(){
                return this.readonly !== undefined && this.readonly !== false
            }
        }

    }
</script>
